exports.en = {
  CZK: 'Kč',
  DOWNLOAD: 'Stáhnout data ve formátu',
  DATE: 'Datum',
  INCREASE: 'Fondový vlastní kapitál v Kč',
  FOND_UNIT_COUNT: 'Počet jednotek',
  FOND_UNIT_VALUE: 'Hodnota jednotky',
  VALORIZATION_PERCENTAGE: 'Změna hodnoty penzijní jednotky v %',
  FUND_NAME_DPS1: 'Konzervativní fond',
  FUND_NAME_DPS2: 'Vyvážený fond',
  FUND_NAME_DPS3: 'Dynamický fond',
  FUND_NAME_DPS4: 'Etický fond',
  NODATA: 'Zadaný rozsah neobsahuje žádná data'
}
